import React from "react";

import Card from "~/account/Integrations/Card";
import MicrosoftTodoLogo from "~/integrations/microsoftTodo/MicrosoftTodoLogo";

interface MicrosoftTodoProps {
	connection: {
		id?: string;
		isConnected?: boolean;
	} | null;
	className?: string;
}

export function MicrosoftTodoCard(props: MicrosoftTodoProps) {
	return (
		<Card
			name="Microsoft To Do"
			description="Create new Microsoft To Do tasks when action items are assigned to you in Fellow."
			connected={props.connection != null}
			logo={<MicrosoftTodoLogo style={{ width: "auto", height: "24px" }} />}
			className={props.className}
		/>
	);
}
